import { createFileRoute } from "@tanstack/react-router"

import { RolesPermissionsAdminPage } from "@/features/admin/components/roles-permissions-admin-page"
import { requirePermissionRouteAccess } from "@/features/authz/require-permission-route-access"

export const Route = createFileRoute("/dashboard/settings/access-control/roles-and-perms")({
	component: RolesPermissionsAdminPage,
	beforeLoad: async ({ context }) => await requirePermissionRouteAccess(context.queryClient, "access.roles.read"),
})
